import { useEffect, useState } from "react";
import { getLobby } from "@/lib/api";

// Polls GET /lobbies/{code}. status: loading | ok | missing (404, polling stops) | offline (keeps polling).
export function useLobby(code, everyMs = 1000) {
  const [lobby, setLobby] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    let alive = true;
    let timer;
    const tick = async () => {
      try {
        const l = await getLobby(code);
        if (!alive) return;
        setLobby(l);
        setStatus("ok");
      } catch (e) {
        if (!alive) return;
        if (e?.response?.status === 404) {
          setStatus("missing");
          return;
        }
        setStatus("offline");
      }
      timer = setTimeout(tick, everyMs);
    };
    tick();
    return () => {
      alive = false;
      clearTimeout(timer);
    };
  }, [code, everyMs]);

  return { lobby, status };
}
